import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FriendlyDurationPipe } from './friendly-duration.pipe';

@NgModule({
  declarations: [FriendlyDurationPipe],
  imports: [CommonModule],
  exports: [FriendlyDurationPipe],
})
export class GaDateTimeModule {}
